<template>
  <vs-popup class=""
            id="popup"
            title="UPDATE SUPPLIER USER"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateStaffUser)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="title" name="title" rules="required" v-slot="{ errors }">
                <small class="label">Title</small>
                <vs-input v-model="createForm.title"   name="title" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="first_name" name="first_name" rules="" v-slot="{ errors }">
                <small class="label">Frist Name</small>
                <vs-input v-model="createForm.first_name"   name="first_name" class="w-full required" label=""/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col  md:w-full w-full md:mb-0">
              <ValidationProvider vid="last_name" name="last_name" rules="" v-slot="{ errors }">
                <small class="label">Last Name</small>
                <vs-input  v-model="createForm.last_name" class="w-full"  name="last_name" type="text" label="" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
              <div class="vx-col w-full md:mb-0">
                <ValidationProvider vid="role" name="role" rules="required" v-slot="{ errors }">
                  <small class="label">User Role</small>
                  <v-select :clearable="false" placeholder="" v-model="createForm.role_id" :reduce="option => option.id" 
                    :options="role_list" 
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" label="name"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRepository = RepositoryFactory.get('supplier')

  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      media: '',
      isImage: '',
      isVideo: '',
      title :'',
      nodata: false,
      isNote:'',
      note:'',
      createForm: {},
      role_list: []
    }
  }

export default {
  name: 'TrackingImagePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.open = true;
        this.id = id;
        await this.fetchSupplierRoleList()
        await this.getSupplierUser()
      } catch (error) {

      }
    },
    async getSupplierUser() {
      this.$vs.loading()
      const {data} = (await SupplierRepository.getSupplierUser(this.id)).data
      console.log(data)
      this.createForm = data
      this.createForm.role_id = data.role ? data.role.id : null
      this.$vs.loading.close()
    },
    async onClickCreateStaffUser (){
      const vue = this;
      this.$vs.loading()
       try {
         await SupplierRepository.updateSupplierUser(this.id, this.createForm)
         this.showSuccessMessage('supplier user updated successfully')
         await vue.$parent.refreshData()
         this.open = false;
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async fetchSupplierRoleList(){
      try {
        const { data } = (await SupplierRepository.getSupplierRoles()).data
        this.role_list = data
      } catch (error) {
        
      }
    }

  },
  async mounted () {

  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .video-wrapper {
    width: 100%;
    height: 100%;
  }

  .video-wrapper video {
    object-fit: cover;
    width: 100%;
    height: 100%;

  }
  .image-wrapper {
    width: 100%;
    height: 75%;
  }


</style>
